import { formatCurrencyAmount } from '../../Locales';
import type {
    GiftCardGranularConditionsOfUse,
    GiftCardPaymentSessionOrderDataQueryResponse,
} from '../../api/graphql/queries/giftCardPaymentSessionOrderData';

export interface OrderData {
    brandName?: string;
    brandLogoUrl?: string;
    cardBackgroundColor?: string;
    cardTextColor?: string;
    items: Array<{ label: string; quantity: number }>;
    totalAmountFormatted: string;
    cashbackAmountFormatted?: string;
    cashbackDescription?: string;
    conditionsOfUseUrl?: string;
    granularConditionsOfUse?: GiftCardGranularConditionsOfUse | null;
}

export function formatOrderData(
    raw: GiftCardPaymentSessionOrderDataQueryResponse['giftCardPaymentSessionOrderData'] | undefined
): OrderData | null {
    if (!raw) return null;
    const totalAmountInCents = raw.giftCards.reduce((sum, gc) => sum + gc.faceAmountInCents * gc.quantity, 0);
    const totalAmountFormatted = formatCurrencyAmount(totalAmountInCents / 100);
    const pointsRate = raw.pointsPerFaceValueMajorCurrencyUnit ?? 0;
    const cashbackPoints = Math.floor(pointsRate * (totalAmountInCents / 100));
    const cashbackAmountFormatted = cashbackPoints > 0 ? formatCurrencyAmount(cashbackPoints / 1000) : undefined;
    return {
        brandName: raw.brandName ?? undefined,
        brandLogoUrl: raw.brandLogoUrl ?? undefined,
        cardBackgroundColor: raw.cardBackgroundColor ?? undefined,
        cardTextColor: raw.cardTextColor ?? undefined,
        items: raw.giftCards.map((gc) => ({
            label: formatCurrencyAmount(gc.faceAmountInCents / 100),
            quantity: gc.quantity,
        })),
        totalAmountFormatted,
        cashbackAmountFormatted,
        conditionsOfUseUrl: raw.conditionsOfUseUrl ?? undefined,
        granularConditionsOfUse: raw.granularConditionsOfUse ?? null,
    };
}
